export const FETCH_TOP_COACHES_BY_HOURS_REQUEST = 'FETCH_TOP_COACHES_BY_HOURS_REQUEST';
export const FETCH_TOP_COACHES_BY_HOURS_SUCCESS = 'FETCH_TOP_COACHES_BY_HOURS_SUCCESS';
export const FETCH_TOP_COACHES_BY_HOURS_FAILURE = 'FETCH_TOP_COACHES_BY_HOURS_FAILURE';

export const FETCH_COACHES_BY_UNIQUE_STUDENTS_REQUEST = 'FETCH_COACHES_BY_UNIQUE_STUDENTS_REQUEST';
export const FETCH_COACHES_BY_UNIQUE_STUDENTS_SUCCESS = 'FETCH_COACHES_BY_UNIQUE_STUDENTS_SUCCESS';
export const FETCH_COACHES_BY_UNIQUE_STUDENTS_FAILURE = 'FETCH_COACHES_BY_UNIQUE_STUDENTS_FAILURE';

export const FETCH_COACHES_TOTAL_RECORDS_REQUEST = 'FETCH_COACHES_TOTAL_RECORDS_REQUEST';
export const FETCH_COACHES_TOTAL_RECORDS_SUCCESS = 'FETCH_COACHES_TOTAL_RECORDS_SUCCESS';
export const FETCH_COACHES_TOTAL_RECORDS_FAILURE = 'FETCH_COACHES_TOTAL_RECORDS_FAILURE';

export const FETCH_RECORDS_BY_TYPE_OF_HOURS_REQUEST = 'FETCH_RECORDS_BY_TYPE_OF_HOURS_REQUEST';
export const FETCH_RECORDS_BY_TYPE_OF_HOURS_SUCCESS = 'FETCH_RECORDS_BY_TYPE_OF_HOURS_SUCCESS';
export const FETCH_RECORDS_BY_TYPE_OF_HOURS_FAILURE = 'FETCH_RECORDS_BY_TYPE_OF_HOURS_FAILURE';

export const FETCH_RECORDS_BY_TYPE_OF_STUDENTS_REQUEST = 'FETCH_RECORDS_BY_TYPE_OF_STUDENTS_REQUEST';
export const FETCH_RECORDS_BY_TYPE_OF_STUDENTS_SUCCESS = 'FETCH_RECORDS_BY_TYPE_OF_STUDENTS_SUCCESS';
export const FETCH_RECORDS_BY_TYPE_OF_STUDENTS_FAILURE = 'FETCH_RECORDS_BY_TYPE_OF_STUDENTS_FAILURE';

export const FETCH_RECORDS_GROUP_BY_COACHES_REQUEST = 'FETCH_RECORDS_GROUP_BY_COACHES_REQUEST';
export const FETCH_RECORDS_GROUP_BY_COACHES_SUCCESS = 'FETCH_RECORDS_GROUP_BY_COACHES_SUCCESS';
export const FETCH_RECORDS_GROUP_BY_COACHES_FAILURE = 'FETCH_RECORDS_GROUP_BY_COACHES_FAILURE';

export const FETCH_TOP_PERFORMING_COACHES_REQUEST = 'FETCH_TOP_PERFORMING_COACHES_REQUEST';
export const FETCH_TOP_PERFORMING_COACHES_SUCCESS = 'FETCH_TOP_PERFORMING_COACHES_SUCCESS';
export const FETCH_TOP_PERFORMING_COACHES_FAILURE = 'FETCH_TOP_PERFORMING_COACHES_FAILURE';

export const FETCH_COACH_DETAILS_REQUEST = 'FETCH_COACH_DETAILS_REQUEST';
export const FETCH_COACH_DETAILS_SUCCESS = 'FETCH_COACH_DETAILS_SUCCESS';
export const FETCH_COACH_DETAILS_FAILURE = 'FETCH_COACH_DETAILS_FAILURE';

export const FETCH_STUDENTS_DETAILS_REQUEST = 'FETCH_STUDENTS_DETAILS_REQUEST';
export const FETCH_STUDENTS_DETAILS_SUCCESS = 'FETCH_STUDENTS_DETAILS_SUCCESS';
export const FETCH_STUDENTS_DETAILS_FAILURE = 'FETCH_STUDENTS_DETAILS_FAILURE';